<template>
  <div>
    <PricingForm is-new />
  </div>
</template>

<script>
import PricingForm from '../components/PricingForm.vue'

export default {
  components: { PricingForm },
}
</script>

<style>

</style>
